declare global {
	interface Window {
		wp: { media: any; i18n: { __(text: string, domain: string): string } };
	}
}

export const __ = (text: string): string => {
	if (window.wp?.i18n) {
		return window.wp.i18n.__(text, "bankmonitor");
	}

	return text;
};

export const getLocale = (): string => {
	if (!document.documentElement.lang?.startsWith("hu")) {
		return "en_US";
	}

	return "hu_HU";
};

export const MONTHS_HUN = [
	"Január",
	"Február",
	"Március",
	"Április",
	"Május",
	"Június",
	"Július",
	"Augusztus",
	"Szeptember",
	"Október",
	"November",
	"December",
];

export const MONTHS_HUN_SHORT = ["jan", "feb", "már", "ápr", "máj", "jún", "júl", "aug", "szep", "okt", "nov", "dec"];
